<div class="wrapper-page-create-list">
  <div class="header-create-list">
    <button (click)="goBack()" class="custom-btn custom-btn--circle-outline">
      <img src="../../../assets/icons/icon-arrow-left.svg" alt="">
    </button>
  </div>
  <form [formGroup]="createListForm" (ngSubmit)="onSubmit()" class="wrapper-content-create-list">
    <div class="content-create-list">
      <h3>{{this.list === null ? ('LIST_SINGLE_PAGE.create_new_list' | translate) : ('Update list' | translate)}}</h3>
      <div class="wrapper-input">
        <span class="label-input">{{'CREATE_NEW_LIST.list_title' | translate}}</span>
        <div class="custom-input">
          <input formControlName="title" type="text" placeholder="{{'NEW_TEXT.enter_list_title' | translate}}">
        </div>
        <div *ngIf="(createListForm.controls['title'] | formControlErrorMessages: null: formTriedToSubmit)"
          class="wrapper-error-message">
          <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
          <span>{{createListForm.controls['title'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
        </div>
        <div *ngIf="!(createListForm.controls['title'] | formControlErrorMessages: null: formTriedToSubmit)"
          class="wrapper-label-gray">
          <span>{{createListForm.controls['title'].value ? (50 - createListForm.controls['title'].value.length) + ' ' +
            ('LIST_SINGLE_PAGE.characters_left' | translate) :
            ('CREATE_NEW_LIST.the_maximum_length_of_a_list_title_is_50_characters' |
            translate)}}</span>
        </div>
      </div>
      <div class="wrapper-upload-image">
        <span class="title-upload-image">
          {{'CREATE_NEW_LIST.cover_image' | translate}}
        </span>
        <div *ngIf="!coverImage" class="upload-image" [ngClass]="{'error': isMaxSizePhotoError}">
          <div class="custom-file-upload">
            <img src="../../../../assets/icons/Icon-upload-image-web.svg" alt="">
            <button type="button" (click)="triggerFileInput($event)" class="custom-btn custom-btn--white">
              <span>
                {{'CREATE_NEW_LIST.add_cover_image' | translate}}
              </span>
            </button>
          </div>
          <input #fileInput type="file" accept=".jpg, .jpeg, .png, .svg" (change)="onFileChange($event)" />
        </div>
        <div *ngIf="isMaxSizePhotoError" class="wrapper-error-message">
          <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
          <span>
            {{'ERROR.your_image_is_too_big_the_maximum_image_size_is' | translate}} 10mb.
          </span>
        </div>
        <div *ngIf="coverImage" class="upload-image">
          <div class="wrapper-preview-image-list">
            <img [src]="coverImage" alt="">
            <div class="btns-preview-image-list">
              <div>
                <label for="change-image" class="custom-btn custom-btn--white">
                  <span>
                    {{'LIST_SINGLE_PAGE.change_cover_image' | translate}}
                  </span>
                </label>
                <input id="change-image" type="file" accept=".jpg, .jpeg, .png, .svg" (change)="onFileChange($event)" />
              </div>
              <button type="button" (click)="isRemoveImageModalOpen = true" class="custom-btn custom-btn--outline">
                <span>
                  {{'FOLLOWING_FOLLOWERS.remove' | translate}}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="(createListForm.controls['cover_image'] | formControlErrorMessages: null: formTriedToSubmit)"
        class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{createListForm.controls['cover_image'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-visibility">
        <span>
          {{'CREATE_NEW_LIST.visibility' | translate}}
        </span>
        <div class="wrapper-toggle-content">
          <span>
            {{'CREATE_NEW_LIST.keep_this_list_private' | translate}}
          </span>
          <div class="custom-toggle-button">
            <input formControlName="visibility" type="checkbox" name="switch" id="switch">
            <label for="switch"></label>
          </div>
        </div>
      </div>
      <button type="submit" [disabled]="formTriedToSubmit" class="custom-btn custom-btn--primary">
        <span>{{list === null ? ('CREATE_NEW_LIST.create_list' | translate) : ('Update list' | translate)}}</span>
      </button>
    </div>
  </form>
</div>
<tl-confirm-modal *ngIf="isRemoveImageModalOpen" [modalIcon]="'../../../../../assets/icons/outline/icon-delete.svg'"
  [modalTitle]="'CREATE_NEW_LIST.remove_current_picture' | translate"
  [confirmBtnText]="'FOLLOWING_FOLLOWERS.remove' | translate"
  [modalDescription]="'Are you sure you want to remove this image for the list cover?'"
  (cancelModal)="isRemoveImageModalOpen = false" (confirmModal)="onConfirmRemoveFile()">
</tl-confirm-modal>
